import {
    PrivateDistributionList,
    createActionFactoryForFeature,
    Feature,
    ThunkDispatch,
    HubPersona,
    Person,
    makeUniqueDistributionListMembers,
    isAnyPersonaMultiEmailPersona,
    flatten,
} from '../../../shared';

import {
    addMembersToPrivateDL,
    removeMembersFromPrivateDL,
    savePrivateDL,
} from '../../../privatedlcreateedit';

const createActionFactory = createActionFactoryForFeature(Feature.ContactListsInCommandBar);

export const addAllPersonasToPDLClickedAction = createActionFactory<{
    personas: HubPersona[];
    currentList: PrivateDistributionList;
}>('AddAllPersonasToPDLClickedAction');

export const createPDLWithAllPersonasClickedAction = createActionFactory<{
    personas: HubPersona[];
    name: string;
}>('CreatePDLWithAllPersonasClickedAction');

export const addSomePersonasToPDLClickedAction = createActionFactory<{
    personas: HubPersona[];
    currentList: PrivateDistributionList;
}>('AddSomePersonasToPDLClickedAction');

export const addSomePersonasAndCreatePDLClickedAction = createActionFactory<{
    personas: HubPersona[];
    listName: string;
    defaultFolderId: string;
}>('AddSomePersonasAndCreatePDLClickedAction');

export const pdlEmailsPickerConfirmClicked = createActionFactory<void>(
    'PdlEmailsPickerConfirmClicked'
);

export const removeAllPersonasFromPDLClickedAction = createActionFactory<{
    personas: HubPersona[];
    currentList: PrivateDistributionList;
}>('RemoveAllPersonasFromPDLClickedAction');

export const dismissPdlEmailsPickerDialog = createActionFactory<void>(
    'DismissPdlEmailsPickerDialog'
);

export const onAddPersonasToPrivateDLClicked = (dispatch: ThunkDispatch) => (
    currentList: PrivateDistributionList,
    personas: HubPersona[]
): Promise<void> => {
    if (isAnyPersonaMultiEmailPersona(personas)) {
        dispatch(addSomePersonasToPDLClickedAction({ personas, currentList }));
        return Promise.resolve();
    } else {
        dispatch(addAllPersonasToPDLClickedAction({ personas, currentList }));
        const membersToAdd = flatten((personas as Person[]).map(makeUniqueDistributionListMembers));
        return addMembersToPrivateDL(dispatch)(currentList, membersToAdd);
    }
};

export const onRemovePersonasToPrivateDLClicked = (dispatch: ThunkDispatch) => (
    currentList: PrivateDistributionList,
    personas: HubPersona[]
): Promise<void> => {
    dispatch(removeAllPersonasFromPDLClickedAction({ personas, currentList }));
    const membersToRemove = flatten((personas as Person[]).map(makeUniqueDistributionListMembers));
    return removeMembersFromPrivateDL(dispatch)(currentList, membersToRemove);
};

export const onCreateNewPrivateDLClicked = (dispatch: ThunkDispatch) => (
    personas: HubPersona[],
    name: string,
    folderId: string
) => {
    if (isAnyPersonaMultiEmailPersona(personas)) {
        dispatch(
            addSomePersonasAndCreatePDLClickedAction({
                personas,
                listName: name,
                defaultFolderId: folderId,
            })
        );
    } else {
        dispatch(createPDLWithAllPersonasClickedAction({ name, personas }));
        const membersToAdd = flatten((personas as Person[]).map(makeUniqueDistributionListMembers));
        savePrivateDL(dispatch)(name, '', membersToAdd, folderId);
    }
};
export type { Action } from '../../../shared';
